import React, {
  ComponentType,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import {
  Autocomplete,
  Button as MUIButton,
  Button,
  Checkbox,
  Chip,
  IconButton,
  Stack,
  Switch,
  Table,
  TextField,
  Typography,
  TableBody,
  TableRow,
  TableContainer,
  Paper,
} from '@mui/material';
import { debounce, values } from 'lodash';
import Box from '@mui/material/Box';
import { SlidingPaneAddNew } from '../../components/Page/SlidingPaneAddNew';
import { SlidingPaneEdit } from '../../components/Page/SlidingPaneEdit';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CardContent from '@mui/material/CardContent';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Unstable_Grid2';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import StatusManagementRow from './StatusManagementRow';
import AddIcon from '@mui/icons-material/Add';
import CircularProgress from '@mui/material/CircularProgress';

const StatusManagementItem = (props) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addNewEntity, setAddNewEntity] = React.useState(false);
  const [openedSlidingPane, setOpenedSlidingPane] = useState(undefined);
  const [openConfirmDialog, setOpenConfirmDialog] = React.useState(undefined);

  const fetchStatuses = useCallback(() => {
    setLoading(true);

    const searchParams = new URLSearchParams({});

    props.schema.client.readAll(1, searchParams).then((result) => {
      setRows(result?.data);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    fetchStatuses();
  }, []);

  const handleDeleteClick = (row) => {
    setOpenConfirmDialog(row);
  };

  const handleEditClick = (row) => {
    setOpenedSlidingPane(row);
  };

  const debouncedOnChange = debounce(handleDebouncedOnChange, 300);

  const moveRow = (fromIndex, toIndex) => {
    debouncedOnChange(fromIndex, toIndex);
  };

  function handleDebouncedOnChange(fromIndex, toIndex) {
    const updatedRows = [...rows];
    const [movedRow] = updatedRows.splice(fromIndex, 1);
    updatedRows.splice(toIndex, 0, movedRow);
    setRows(updatedRows);

    updatedRows.map((item, index) => {
      props.schema.client.update(item?.id, {
        range: index,
      });
    });
  }

  return (
    <>
      <Grid sm={12} md={6} lg={3}>
        <Box sx={{}}>
          <Card variant="outlined">
            <CardContent>
              <Typography variant={'h6'} color="#666" gutterBottom>
                {props.schema?.name}
              </Typography>
              <TableContainer>
                <Table
                  sx={{
                    '& .MuiTableCell-root': {
                      padding: '5px',
                    },
                    opacity: loading ? 0.5 : 1,
                    pointerEvents: loading ? 'none' : 'all',
                  }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">Icon</TableCell>
                      <TableCell align="left">Name</TableCell>
                      <TableCell align="center">End Status</TableCell>
                      <TableCell align="center">Booked End Status</TableCell>
                      <TableCell align="center">Active</TableCell>
                      <TableCell align="right"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loading ? (
                      <>
                        <TableRow>
                          <TableCell colSpan={6}>
                            <Stack
                              alignItems={'center'}
                              sx={{
                                width: '100%',
                              }}
                            >
                              <CircularProgress size={30} />
                            </Stack>
                          </TableCell>
                        </TableRow>
                      </>
                    ) : (
                      <>
                        {rows.map((row, index) => (
                          <StatusManagementRow
                            key={row.id}
                            schema={props.schema}
                            row={row}
                            index={index}
                            moveRow={moveRow}
                            clickOnDelete={(value) => {
                              handleDeleteClick(value);
                            }}
                            clickOnEdit={(value) => {
                              handleEditClick(value);
                            }}
                          />
                        ))}
                      </>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <Stack alignItems={'flex-start'}>
                <IconButton
                  color={'primary'}
                  onClick={() => {
                    setAddNewEntity(true);
                  }}
                >
                  <AddIcon />
                </IconButton>
              </Stack>
            </CardContent>
          </Card>
        </Box>
      </Grid>

      {addNewEntity && (
        <SlidingPaneAddNew
          schema={props.schema}
          id={undefined}
          onSubmit={() => {
            fetchStatuses();
            setAddNewEntity(false);
          }}
          propertiesFromTable={{}}
          onClose={(value) => {
            fetchStatuses();
            setAddNewEntity(false);
          }}
        />
      )}

      {openedSlidingPane && (
        <SlidingPaneEdit
          schema={props.schema}
          id={openedSlidingPane?.id}
          onSubmit={() => {
            console.log('ASD______________________---1');
            fetchStatuses();
            setOpenedSlidingPane(undefined);
          }}
          propertiesFromTable={openedSlidingPane}
          onClose={(value) => {
            console.log('ASD______________________---2');
            setOpenedSlidingPane(undefined);
          }}
        />
      )}

      {openConfirmDialog && (
        <>
          <Dialog
            open={true}
            onClose={() => {
              setOpenConfirmDialog(undefined);
            }}
          >
            <DialogTitle>Are you sure you want to delete it?</DialogTitle>
            <DialogContent
              sx={{
                fontSize: {
                  xs: '14px',
                },
              }}
            >
              {`${openConfirmDialog.name}`}
            </DialogContent>
            <DialogActions>
              <MUIButton
                onClick={() => {
                  setOpenConfirmDialog(undefined);
                }}
              >
                Cancel
              </MUIButton>
              <MUIButton
                variant={'contained'}
                color={'error'}
                onClick={() => {
                  props.schema.client
                    .delete(openConfirmDialog.id, {})
                    .then((res) => {
                      setOpenConfirmDialog(undefined);
                      fetchStatuses();
                    })
                    .catch((e) => {});
                }}
                autoFocus
              >
                Delete
              </MUIButton>
            </DialogActions>
          </Dialog>
        </>
      )}
    </>
  );
};
export default StatusManagementItem;
